import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../ui/Button';

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="fixed inset-x-0 top-0 z-40 w-full bg-white/95 backdrop-blur-xl border-b border-slate-100 shadow-card">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-6 lg:px-8">
        {/* Logo Section - Always Visible */}
        <Link to="/" className="flex items-center gap-2 transition hover:opacity-80 flex-shrink-0">
          <div className="relative h-10 w-10 overflow-hidden rounded-xl border border-slate-200 bg-transparent shadow-card">
            <img
              src={`${process.env.PUBLIC_URL}/images/logo.png`}
              alt="Tuma Jobs"
              className="h-full w-full object-cover"
            />
          </div>
          <div>
            <p className="text-base font-bold tracking-tight text-navy">Tuma Jobs</p>
            <p className="text-xs text-orange font-semibold">Jobs</p>
          </div>
        </Link>

        {/* Desktop Menu */}
        <div className="hidden sm:flex items-center gap-4">
          <Link
            to="/"
            className="text-sm font-medium text-slate-700 transition hover:text-navy"
          >
            Browse jobs
          </Link>
          <Link to="/login">
            <Button variant="primary">Login</Button>
          </Link>
        </div>

        {/* Mobile Post Button */}
        <div className="flex sm:hidden flex-shrink-0">
          <Link to="/login">
            <Button variant="primary">Login</Button>
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;